import { render, staticRenderFns } from "./setpaypwd.vue?vue&type=template&id=48c48680&scoped=true"
import script from "./setpaypwd.vue?vue&type=script&lang=js"
export * from "./setpaypwd.vue?vue&type=script&lang=js"
import style0 from "./setpaypwd.vue?vue&type=style&index=0&id=48c48680&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c48680",
  null
  
)

export default component.exports